// import { getTTFB } from './ttfb';
import { getTTDI } from './ttdi';
import { getPLT } from './plt';
import { whenLoaded } from '../../utils/whenLoaded';
/**
 * Calculates navigation timing metrics using the Navigation Timing API.
 * Metrics:
 * - time.to.dom.interactive
 * - page.load.time
 */
export function navigationTiming() {
    return function onNavigationTimingMetrics(ctx) {
        var getMetrics = function () {
            var ttdi = getTTDI(), 
            // ttfb = getTTFB(),
            plt = getPLT();
            if (ttdi)
                ctx.track(ttdi);
            // @TODO regarding `time.to.first.byte`, either rename to `server.time.to.first.byte`, update its definition (https://web.dev/ttfb/), or remove it. For now, the metric is also provided by webVitals collector.
            // if (ttfb) ctx.track(ttfb);
            if (plt)
                ctx.track(plt);
        };
        whenLoaded(getMetrics);
        return {
            flush: getMetrics
        };
    };
}
